import { useNavigate, Link } from "react-router-dom";
import { useState } from "react";
import { useStore } from "@/store/useStore";
import { Button } from "@/components/Button";
import { Logo } from "@/components/AppShell";
import { useToast } from "@/components/Toast";

export default function Login() {
  const navigate = useNavigate();
  const login = useStore((s) => s.login);
  const toast = useToast((s) => s.push);
  const [username, setUsername] = useState("you");
  const [password, setPassword] = useState("password123");

  const submit = async () => {
    try {
      await login(username, password);
      toast({ tone: "ok", title: "Signed in", desc: "Backend session active." });
      navigate("/app");
    } catch (e: any) {
      toast({ tone: "error", title: "Sign in failed", desc: e.message });
    }
  };

  return (
    <div className="min-h-screen bg-strain-field grid place-items-center px-4">
      <div className="w-full max-w-sm">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8">
          <Logo className="w-8 h-8" />
          <span className="text-lg font-semibold tracking-tight">idea<span className="text-[var(--color-primary)]">strains</span></span>
        </Link>

        <div className="rounded-2xl border border-[var(--color-border)] bg-[var(--color-surface)] p-6 shadow-card">
          <h1 className="text-lg font-semibold mb-1">Welcome back</h1>
          <p className="text-[13px] text-[var(--color-ink-muted)] mb-4">
            Try <span className="font-mono">you</span> / <span className="font-mono">password123</span>, or any seeded username with that password.
          </p>
          <div className="space-y-3">
            <div>
              <label className="text-[10px] font-mono uppercase tracking-wider text-[var(--color-ink-muted)]">username</label>
              <input value={username} onChange={(e) => setUsername(e.target.value)} placeholder="you" className="mt-1 w-full h-10 px-3 rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-2)] text-sm text-[var(--color-ink)]" />
            </div>
            <div>
              <label className="text-[10px] font-mono uppercase tracking-wider text-[var(--color-ink-muted)]">password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="password123" className="mt-1 w-full h-10 px-3 rounded-lg border border-[var(--color-border)] bg-[var(--color-surface-2)] text-sm text-[var(--color-ink)]" />
            </div>
            <Button className="w-full" onClick={submit}>Sign in</Button>
          </div>
          <div className="mt-4 text-center text-[12px] text-[var(--color-ink-muted)]">
            No account? <Link to="/signup" className="text-[var(--color-primary)] hover:underline">Sign up</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
